let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lz7EL")).then(() => parcelRequire('9cETc'));